<template>
  <el-dialog
    title="备注"
    :visible.sync="showDialog"
    width="30%"
    class="remarkDialog"
    @close="closeDialog(0)"
    @before-close="closeDialog(0)"
  >
    <p v-if="readOnly">
      标记：
      <span
        class="iconfont iconqizi_icon"
        :style="showColor"
      ></span>
    </p>
    <p v-else>
      标记：
      <span
        class="iconfont iconqizi_icon"
        v-for="(item, index) in signColorList"
        :key="index"
        :style="item.color"
        @click="selectSignColor(index)"
        :class="{ colorBorder: item.selected }"
      ></span>
      <input type="color" id="colorSelecter" @change="getNewColor()" />
    </p>
    <div v-if="readOnly" style="margin-top:20px;">
      <span>详细说明：</span>
      <span>{{formData.tag_content}}</span>
    </div>
    <el-form :model="signForm" :rules="rules" ref="signForm" v-else>
      <el-form-item label="详细说明" prop="tag_content">
        <el-input
          type="textarea"
          v-model="signForm.tag_content"
          placeholder="200字以内"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" v-if="!readOnly">
      <el-button @click="closeDialog(0)">取 消</el-button>
      <el-button type="primary" @click="save()" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { EditTag } from "@/api/order";
export default {
  props: {
    show_sign_dialog: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  watch: {
    show_sign_dialog(val) {
      this.showDialog = val;
      if(val){
        this.signForm.tag_content = this.formData.tag_content
      }
      this.readOnly = this.formData.readonly;
      this.showColor = this.formData.color;
    }
  },
  data() {
    return {
      signForm: {
        tag_color: "#FF8525",
        tag_content: "",
      }, //备注表单
      signColorList: [
        { color: "color:#FF8525", selected: true },
        { color: "color:red", selected: false },
        { color: "color:#17E716", selected: false },
        { color: "color:#2327E5", selected: false }
      ], //标记颜色列表
      showDialog: false,
      showColor: "color:#ff8525",
      readOnly: false,
      rules: {
        tag_content: [
          { required: true, message: "请输入详细说明", trigger: "blur" }
        ]
      },
      loading: false
    };
  },
  methods: {
    //新增标记颜色
    getNewColor() {
      var newcolor = document.querySelector("#colorSelecter").value;
      console.log(newcolor);
      var d = {
        color: "color:" + newcolor,
        selected: true
      };
      this.signColorList.forEach(item => {
        item.selected = false;
      });
      this.signForm.tag_color = newcolor;
      this.signColorList.push(d);
    },
    //选择标记颜色
    selectSignColor(i) {
      this.signColorList.forEach(item => {
        item.selected = false;
      });
      this.signColorList[i].selected = true;
      console.log("select", this.signColorList[i]);
      this.signForm.tag_color = this.signColorList[i].color.split(":")[1];
    },
    //关闭
    closeDialog(rel) {
      console.log(rel)
      this.$emit("close", rel);
    },
    //保存
    save() {
      this.loading = true;
      var data = Object.assign({}, this.signForm);
      data.token = this.formData.token;
      data.app_id = this.formData.app_id;
      data.ordersn = this.formData.ordersn;
      console.log(data);
      this.$refs.signForm.validate(valid => {
        if (valid) {
          EditTag(data).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg
              });
              this.closeDialog(1);
            } else {
              this.$message({
                type: "warning",
                message: res.msg
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
        this.loading = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
// 标记弹窗
.remarkDialog {
  p {
    span {
      color: red;
      margin-right: 10px;
    }
    .colorBorder {
      border: 1px solid #397dff;
    }
  }
}
</style>
